import Levels from './levels.json';

export default Levels;


// WEBPACK FOOTER //
// ./src/data/index.js